import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, isDevMode} from '@angular/core';
import {DemoService} from '../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, Subscription} from 'rxjs';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import {SystemFile} from './../../../../shared/models/file.model';

// Environmental Variables
import { environment } from './../../../../../environments/environment';
import { DatePicker } from '@syncfusion/ej2-angular-calendars';
import { GridComponent, SearchSettingsModel, FilterSettingsModel, IFilter, ToolbarItems, GroupSettingsModel, IFilterUI } from '@syncfusion/ej2-angular-grids';
import { RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
  import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
  import { DataManager  } from '@syncfusion/ej2-data';

@Component({
  selector: 'app-file-details-widget',
  templateUrl: './file-details-widget.component.html',
  styleUrls: ['./file-details-widget.component.css']
})
export class FileDetailsWidgetComponent implements OnInit, OnChanges {


  @Input() file_id?: Observable<any[]>;
  @Input() file_data?: any;
  @Input() permission_check?: boolean;
  file: SystemFile;


  // June 2025 update
    @Input() file_name?: any; // new lookup file if no file id check for name..

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '';
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full | info
  returned_file_data: Object;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  
  agent_array: any;
  show_agents: any;
  assigned_to_subjects: any;
  files_assigned_from: any;
  files_assigned_from2: any;
  assigned_to_agents: any;


  // @ViewChild('grid')
  @ViewChild('grid') public gridObj: GridComponent;
  public grid: GridComponent;
  public searchOptions: SearchSettingsModel;
 
  public pageSettings: Object;
  public pageOptions = { pageSize: 20 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: any;
  // public filterOptions: FilterSettingsModel;
  public filter: IFilter;
  public toolbarOptions: ToolbarItems[] | object;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };
  dateFormat: string;
  files: any;
  modalRef: BsModalRef;
  assignedAgentsList: Object;
  allAgentsAssigned: any[];
  agent_access_array: any;
  report_access_array: any;
  invoice_access_array: any;
  user_access_array: any;
  del_files: Object;
  file_password_data: any;
  file_password: any;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService



  ) {
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

        // Setup Grid
        this.toolbarOptions = []; 

        // this.toolbarOptions = ['Search'];
        // this.toolbarOptions = ['ExcelExport', 'Search'];

        // this.toolbar = [
        // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];
      //  this.initialPage = { pageSize: 100 };
        this.filterOptions = {
          type: 'Menu'
        };
        this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
        this.formatOptions = { type: 'date', format: 'dd/MM/yyyy' };
        this.dateFormat = 'dd/MM/yyyy hh:mm a';
        this.filter = { params: { format: this.dateFormat } };


   }



      // check for changes. to load data.
      ngOnChanges(changes) {
        if (changes.item_id) {
          // deal with asynchronous Observable result
          this.file_id = changes.item_id.currentValue;
          
              // load data from sent ID
              if (!this.file_data){
                this.getSystemFile(this.file_id);
                this.getSystemFileAssignedFrom(this.file_id); // assigned files if data was passed
              }else{
             // this.file_data = this.returned_file_data;
  
              }



              if(!this.file_id){
                this.toastr.info('looking up file by name:' + this.file_name)
                 this.getSystemFileByName(this.file_name)
              }

        }
      }

  ngOnInit() {

    if (isDevMode()) {
      console.log('Development!');
      console.log('fileURL: ', environment.$fileURL);
    } else {
      console.log('Production!');
    }

  }



  getSystemFile(file_id){

    this.show_agents = [];
    this._demoService.getSystemFile(file_id).subscribe(
       data => { this.file_data = data;
      let res = data[0];
      

      // Agent Permissions and Arrays Setups - agents linked to the subject if a subject file. and Agent Level Access
   // load the agent Permissions (assinged_to_agents ) - on create file

   
   this.getSubjectAgentBrandsAssigned(res.file_subject_id);
   
   this.agent_access_array = JSON.parse(res.agent_access_array);
   this.report_access_array = JSON.parse(res.report_access_array);
   this.invoice_access_array = JSON.parse(res.invoice_access_array);
   this.user_access_array = JSON.parse(res.user_access_array);

    this.assigned_to_subjects = JSON.stringify(res.assigned_to_subjects);
      this.assigned_to_agents = JSON.stringify(res.assigned_to_agents);

      // array for agents display test may not be correct if other agents?
let newArrA = res;
//  let  count_of_items = Object.keys(newArrA).length;
let  count_of_items = Object.keys(newArrA).length;
   // need to do a loop of subject_billing items (.length)
   for(let i=0;i < count_of_items; i++) {
   let res22 = newArrA[i];

   // just grabs the first agent. // as pass was throwing errors. // end of json.

   // this.agent_array = JSON.parse(res22.assigned_to_agents);
   

 

//    this.show_agents.push({
//      recipient_name: res22.recipient_name + '',
//      recipient_email_address: newArrA[i].recipient_email_address,
//      recipient_brand_id: res22.recipient_brand_id,
//      recipient_subject_id: res22.subject_id,
//      recipient_brand_type_id: res22.brand_type_id,
//      recipient_user_id: null,
//      recipient_user_level_id: null,
//      recipient_type_name: res22.recipient_type_name,
//    });
   } // end for loop
//  this.show_agents = this.show_agents; // ?? this may be causing errors.
// console.log(JSON.stringify(this.agent_array));

this.show_agents = this.agent_array; // ?? this may be causing errors.
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }





  getSystemFileByName(file_name){

    this.show_agents = [];
    this._demoService.getSystemFileByName(file_name).subscribe(
       data => { this.file_data = data;
      let res = data[0];
      

      // Agent Permissions and Arrays Setups - agents linked to the subject if a subject file. and Agent Level Access
   // load the agent Permissions (assinged_to_agents ) - on create file

   
   this.getSubjectAgentBrandsAssigned(res.file_subject_id);
   
   this.agent_access_array = JSON.parse(res.agent_access_array);
   this.report_access_array = JSON.parse(res.report_access_array);
   this.invoice_access_array = JSON.parse(res.invoice_access_array);
   this.user_access_array = JSON.parse(res.user_access_array);

    this.assigned_to_subjects = JSON.stringify(res.assigned_to_subjects);
      this.assigned_to_agents = JSON.stringify(res.assigned_to_agents);

      // array for agents display test may not be correct if other agents?
let newArrA = res;
//  let  count_of_items = Object.keys(newArrA).length;
let  count_of_items = Object.keys(newArrA).length;
   // need to do a loop of subject_billing items (.length)
   for(let i=0;i < count_of_items; i++) {
   let res22 = newArrA[i];

   // just grabs the first agent. // as pass was throwing errors. // end of json.

   // this.agent_array = JSON.parse(res22.assigned_to_agents);
   

 

//    this.show_agents.push({
//      recipient_name: res22.recipient_name + '',
//      recipient_email_address: newArrA[i].recipient_email_address,
//      recipient_brand_id: res22.recipient_brand_id,
//      recipient_subject_id: res22.subject_id,
//      recipient_brand_type_id: res22.brand_type_id,
//      recipient_user_id: null,
//      recipient_user_level_id: null,
//      recipient_type_name: res22.recipient_type_name,
//    });
   } // end for loop
//  this.show_agents = this.show_agents; // ?? this may be causing errors.
// console.log(JSON.stringify(this.agent_array));

this.show_agents = this.agent_array; // ?? this may be causing errors.
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }




    getSystemFileAssignedFrom(file_id){
      this._demoService.getSystemFileAssignedFrom(file_id).subscribe(
         data => { this.files_assigned_from = data;
        let res = data[0];
        this.files_assigned_from2 = JSON.stringify(this.files_assigned_from);
        
console.log('Files Assigned: ', this.files_assigned_from2);

        },
         err => console.log(err),
         // () => console.log('done loading Trace Types')
       );
      }

    editSystemFile(file_id) {
      // this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
      this.gfunc.globalEditSystemFile(file_id);
    }







// nSome grid functions

toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}


clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.files }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);
    
   // this.search_results = pdfdata.records; // need this if a grouping is set.
/*     this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

}


// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  // this.refreshGrid();
  this.modalRef.hide();
 
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div

// :: Reloads the email list


};






// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned(subject_id) {
  this.allAgentsAssigned = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentsAssigned.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allAgentsAssigned = this.allAgentsAssigned; // ?? this may be causing errors.

       // do an array compaire and remove if not the same.
       
       // set records to send to subject_notes data table
      // this.model.assigned_to_agents  = JSON.stringify(this.allRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


 RemoveElementFromAllAgentsAssigned(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentsAssigned.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentsAssigned.splice(index, 1);
    }
  });

  // now reset the edit form value
         // set records to send to subject_notes data table
        //  JSON.parse();
 // this.model.assigned_to_agents = JSON.stringify(this.allAgentsAssigned);


    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};





deleteSystemFileAssigned(model){
  this._demoService.deleteSystemFileAssigned(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('Assigned Files deleted', model.file_id + ' ' + model.full_file_name),
      // this.files_table = this.files.slice(0, 10)
      this.toastr.success( "Assigned/Shared File Records Removed")
      ),
    (err) => console.error(err.status)
  );
}

deleteSystemFile(model){
  if (confirm('Are you sure you want to delete this file assign/share record, master file will remain? ')) {
  this._demoService.deleteSystemFile(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('File deleted', model.file_id + ' ' + model.full_file_name),
      // this.files_table = this.files.slice(0, 10)
      this.toastr.success( "Assigned/Shared File Record Removed"),
      this.getSystemFileAssignedFrom(this.file_id),
      this.getSystemFile(this.file_id), // refresh the lot.
      this.grid.refresh() 
      // this.refreshGrid()
      ),
    (err) => console.error(err.status)
  );
    }
}



// this deletes the lot!
deleteSystemJobFile(model) {
  console.log('FileID: ', model.file_id);
  if (confirm('Are you sure you want to delete this file, data and associations from the system? ')) {
  // change into a subscruption and delete the file action.
// 1: delete from database + Log action
this.deleteSystemFileAssigned(model);
// 2: Delete file from server
this.deleteSystemFile(model);
// logg the process
this.gfunc.insertLog_DeleteSystemFile(model);
// 3: Delete the pysical file from the server file
if (model.file_server_location !== '') {
this.deleteJobFileAny(model.full_file_name, model.file_job_id, model.file_make, model.file_server_location);
console.log('physicalFILEdelete active: ');
// find out what type of tile it is and then detete the file.
}
console.log('Success: Data + File deleted', model.file_id + ' ' + model.full_file_name);
// this.refreshGrid();
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
 // this.gfunc.globalViewSystemFile(file_id);


  } // end confirm
}


// New delete any job or subject file fuction - Beta Testing
deleteJobFileAny(filename, job_id, file_make, file_server_location) {
  // if (confirm('Are you sure you want to delete this file? ')) {
    this._mysqlService.deleteJobFileAny(filename, job_id, file_make, file_server_location).subscribe(
       data => {
         // this.getTraceNotes(this.trace_id);
        // this.refreshGrid();
         return true;
       },
       error => {
         console.error('Error deleting Job File!');
        //  return Observable.throw(error);
       }
    );
// }
}



editDocFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
  this.gfunc.globalEditDocFile(file_id);
}


editDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  this.gfunc.globalEditDocxSystemFile(file_id);
}

editDocxSystemFileHTML(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit-html/' + file_id + '']);
}



viewDocxSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  this.gfunc.globalViewDocxSystemFile(file_id);
}

viewDocxSystemFileHTML(file_id) {
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view-html/' + file_id + '']);
}

subjectEditLink(subject_id) { 
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
this.gfunc.globalJobSubjectViewSkipRoute(subject_id);
}


viewSystemFile(file_id) {
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  this.gfunc.globalViewSystemFile(file_id);
}



getFilePasswordKeyHash(model) {
  this._demoService.getFilePasswordKeyHash(model)
  .pipe(
    this.toastr.observe({
       loading: '... decrypting key',
       success: '🚀 ... Showing Password',
       error: '😡'
    })
  )
  .subscribe(
    data => { 
      this.file_password_data = data;
      this.file_password = this.file_password_data.file_password
    
    },
    err => console.error(err),
    () => console.log('done loading company')
  );
}


// copy to clipbard button
// ::@ https://stackoverflow.com/questions/49102724/angular-5-copy-to-clipboard
copyMessage(val: string){
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.toastr.success(val + '');
}




encryptSystemFile(model) {
  // generate more data first
   if (confirm('Are you sure you want to encrypt and lock file with a password? ')) {
  this._mysqlService.encryptSystemFile(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Document Encryption Success.');
      const res = data;
      this.getSystemFile(this.file_id);
      // this.getSystemFileAssignedFrom(this.file_id); // assigned files if data was passed
    },
    (error) => {
     return error.error;
    },
    //  () => console.log('')
  );
   }
}


}
